import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import { INSTAGRAM_DM_URL } from './data';

export const InstagramFab = () => (
  <motion.a
    href={INSTAGRAM_DM_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="instagram-dm-fab"
    initial={{ opacity: 0, scale: 0.8, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1, duration: 0.4 }}
    whileHover={{ y: -3 }}
    className="fixed bottom-5 left-5 z-[90] group flex items-center gap-2.5 rounded-full pl-3 pr-4 py-3 text-white font-heading uppercase text-sm tracking-wide shadow-[0_8px_30px_rgba(255,46,46,0.35)]"
    style={{
      background:
        'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
    }}
    aria-label="Enviar mensaje directo por Instagram"
  >
    <span className="relative flex h-6 w-6 items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-60" />
      <Instagram size={22} className="relative" />
    </span>
    <span className="hidden sm:inline">Escríbeme por DM</span>
    <span className="sm:hidden">DM</span>
  </motion.a>
);
